import React, { useState } from 'react';
import AuthPortal from './AuthPortal';

const LoginRequired = () => {
  const [showAuth, setShowAuth] = useState(false);

  return (
    <div style={{ textAlign: 'center', marginTop: '60px' }}>
      <h2>Please log in to access the Dashboard</h2>
      <button onClick={() => setShowAuth(true)} style={{ margin: '20px', padding: '10px 20px', fontSize: '1em' }}>
        Log In
      </button>
      {showAuth && <AuthPortal onClose={() => setShowAuth(false)} />}
    </div>
  );
};

export default LoginRequired; 